import React from 'react'
import SubscriptionPayModal from 'shared-components/modals/SubscriptionPayModal/SubscriptionPayModal'

export default function SubscriptionPayment() {
    return <SubscriptionPayModal open={true} />
}
